import {
  Menu,
  MenuButton,
  IconButton,
  Portal,
  MenuList,
  MenuItem,
  useDisclosure,
  MenuDivider,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Icons, defaultIconSize } from '../../Icons';
import { transportRequestEvents } from '../../transportRequests/events';
import { RemoveSamplesFromTransportRequestModal } from '../../transportRequests/RemoveSamplesFromTransportRequestModal';
import { UpdateTransportRequestModal } from '../../transportRequests/UpdateTransportRequest';
import {
  SampleNextActionProps,
  GeneralSamplesMenuActions,
  useGeneralSampleModals,
} from '../SampleNextAction';
import { usePortalRefValue } from '@texas/hooks/usePortalRef';

export function UpdateTransportRequestWithoutShipment(
  props: SampleNextActionProps,
) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();
  const { t } = useTranslation();
  const {
    setLostOnOpen,
    updateOwnerOnOpen,
    rejectOnOpen,
    stopFollowOnOpen,
    modals,
  } = useGeneralSampleModals();

  const { ref } = usePortalRefValue();

  if (!props.sampleId || !props.transportRequestId) {
    return null;
  }

  return (
    <>
      <Menu isLazy={true}>
        <MenuButton
          as={IconButton}
          size="sm"
          variant="ghost"
          aria-label={t('sample.menu')}
          icon={<Icons.DotsHorizontal boxSize={defaultIconSize} />}
        />
        <Portal containerRef={ref}>
          <MenuList zIndex={10}>
            <MenuItem
              onClick={onOpen}
              icon={<Icons.Close boxSize={defaultIconSize} />}
            >
              {t('sample.removeFromTransportRequest')}
            </MenuItem>
            <MenuItem
              onClick={onOpen2}
              icon={<Icons.Pencil boxSize={defaultIconSize} />}
            >
              {t('transportRequest.update')}
            </MenuItem>
            <MenuDivider />
            <GeneralSamplesMenuActions
              pas={[props.pa!]}
              sampleIds={[props.sampleId]}
              rejectOnOpen={rejectOnOpen}
              setLostOnOpen={setLostOnOpen}
              updateOwnerOnOpen={updateOwnerOnOpen}
              stopFollowOnOpen={
                props.hideStopFollowing ? null : stopFollowOnOpen
              }
            />
          </MenuList>
        </Portal>
      </Menu>

      {modals}
      <RemoveSamplesFromTransportRequestModal
        isOpen={isOpen}
        onClose={onClose}
        sampleIds={[props.sampleId]}
        onPerformed={() => transportRequestEvents.onSamplesRemoved.dispatch()}
      />
      <UpdateTransportRequestModal
        isOpen={isOpen2}
        onClose={onClose2}
        trId={props.transportRequestId}
      />
    </>
  );
}
